import React from 'react';
import LegalPage from './LegalPage';
import { privacyContent } from '../data/legalContent';

const Privacy = () => (
  <LegalPage title="Privacy Policy" eyebrow="Metaxu One Private Limited" content={privacyContent} />
);

export default Privacy;
